import pxToRem from 'assets/theme/function/px-to-rem';

const tableHead = {
    styleOverrides: {
        root: {
            backgroundColor: 'transparent',
            height: pxToRem(40),
        },
    },
};

export default tableHead;
